var input = document.getElementById('placesAutocomplete');
if(input !== null) {
    var autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: {country: 'GB'}
    });
}
